<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'violation',
      getListUrl: 'getViolationStatistics',
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
          className: "carcap",
        },
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "violation_count", label: "违章次数", minwidth: 120 },
        { keyName: "unresolved_count", label: "待处理", minwidth: 120 },
        { keyName: "resolved_count", label: "已处理", minwidth: 120 },
        { keyName: "total_kpoints", label: "扣分总计", minwidth: 120 },
        { keyName: "unresolved_fine", label: "待处理罚款", minwidth: 120 },
        { keyName: "resolved_fine", label: "已处理罚款", minwidth: 120 },
        { keyName: "total_fine", label: "罚款总额", minwidth: 120 },
      ],
      btns: [
        {
          title: '违章明细',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ license }) => {
            this.$router.push(
              `/vehicle/breakRules/detailList?license=${license}`
            );
          },
        },
      ],
    };
  },
  methods: {},
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(0, 1)
      this.baseParams.push('fleet')
    }
  },
  mounted() {
    this.getFleet();
    const { user_group_id } = this.user
    if (user_group_id == 5) {
      // 由于本身没有baseParams，有了baseParams手动触发首次请求
      this.$nextTick(this.getList);
    }
  },
};
</script>
